
module.constant('eflNames', [
    'Beginning ABE Literacy',
    'Beginning Basic Education',
    'Low Intermediate Basic Education',
    'High Intermediate Basic Education',
    'Low Adult Secondary Education',
    'High Adult Secondary Education',
]);
